import { render, staticRenderFns } from "./HomeOpeningImage.vue?vue&type=template&id=04bbed2a&scoped=true"
import script from "./HomeOpeningImage.vue?vue&type=script&lang=js"
export * from "./HomeOpeningImage.vue?vue&type=script&lang=js"
import style0 from "./HomeOpeningImage.vue?vue&type=style&index=0&id=04bbed2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bbed2a",
  null
  
)

export default component.exports